const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrankensteinSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x35_",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -50 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D76A77"
    },
    d: "M0,402.544h187.886L87.348,302.006C33.808,326.5,0,362.461,0,402.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CB6072"
    },
    d: "M256.001,268.895c-64.605,0-123.608,12.5-168.653,33.11l100.538,100.539H512 C512,328.735,397.384,268.895,256.001,268.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8492A9"
    },
    d: "M162.976,189.012c0,23.762-19.267,43.025-43.029,43.025c-23.767,0-43.028-19.264-43.028-43.025 c0-23.764,19.261-43.028,43.028-43.028C143.709,145.984,162.976,165.248,162.976,189.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8492A9"
    },
    d: "M438.354,189.012c0,23.762-19.267,43.025-43.029,43.025c-23.761,0-43.028-19.264-43.028-43.025 c0-23.764,19.267-43.028,43.028-43.028C419.087,145.984,438.354,165.248,438.354,189.012z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 75.041,
    y: 84.381,
    style: {
      fill: "#AFAFAF"
    },
    width: 75.558,
    height: 41.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.377,
    y: 84.381,
    style: {
      fill: "#999A9A"
    },
    width: 7.111,
    height: 41.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.486,
    y: 84.381,
    style: {
      fill: "#999A9A"
    },
    width: 7.115,
    height: 41.778
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3C4C4"
    },
    d: "M81.142,130.038c0,7.576-6.139,13.715-13.715,13.715l0,0c-7.576,0-13.721-6.139-13.721-13.715 V80.501c0-7.576,6.145-13.715,13.721-13.715l0,0c7.576,0,13.715,6.139,13.715,13.715V130.038z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#95A8AD"
    },
    d: "M319.584,51.617l-62.51,62.501l-62.509-62.501l-62.5,62.501l-16.502-16.502V321.91 c0,26.404,21.407,47.807,47.804,47.807h187.415c26.4,0,47.801-21.403,47.801-47.807V97.616l-16.502,16.502L319.584,51.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8FAEB3"
    },
    d: "M319.584,51.617l-62.51,62.501l-62.509-62.501l-62.5,62.501l-16.502-16.502V321.91 c0,26.404,21.407,47.807,47.804,47.807h187.415c26.4,0,47.801-21.403,47.801-47.807V97.616l-16.502,16.502L319.584,51.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0B495"
    },
    d: "M235.649,291.318c0-26.404-21.413-47.804-47.814-47.804h-72.273v78.396 c0,26.404,21.407,47.807,47.804,47.807h72.282V291.318z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1A48C"
    },
    d: "M178.82,237.776h-9.557c-3.169,0-5.744,2.57-5.744,5.738c0,3.166,2.575,5.735,5.744,5.735h9.557 c3.17,0,5.733-2.57,5.733-5.735C184.553,240.346,181.99,237.776,178.82,237.776z M226.659,254.445 c-2.462-2.585-5.164-4.924-8.093-6.976c-2.601-1.824-6.174-1.196-7.992,1.395c-1.818,2.595-1.2,6.174,1.401,7.995 c2.298,1.613,4.431,3.453,6.363,5.489c2.184,2.294,5.808,2.389,8.106,0.205C228.743,260.373,228.831,256.74,226.659,254.445z  M241.381,302.795v-9.561c0-3.172-2.576-5.738-5.732-5.738c-3.17,0-5.745,2.566-5.745,5.738v9.561 c0,3.169,2.575,5.738,5.745,5.738C238.805,308.534,241.381,305.964,241.381,302.795z M241.381,350.605v-9.564 c0-3.169-2.576-5.738-5.732-5.738c-3.17,0-5.745,2.57-5.745,5.738v9.564c0,3.169,2.575,5.735,5.745,5.735 C238.805,356.34,241.381,353.774,241.381,350.605z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7095B8"
    },
    d: "M398.583,97.616l-3.106,3.115l0,0l-13.396,13.386l-62.497-62.501l-48.268,48.256 c-3.295,12.477-5.075,25.573-5.075,39.089c0,77.361,57.661,141.196,132.342,150.993V97.616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657762"
    },
    d: "M260.496,138.962c0,1.657,0.025,3.311,0.076,4.956c0.101,3.169,2.752,5.66,5.909,5.561 c3.169-0.094,5.656-2.743,5.568-5.912c-0.05-1.528-0.076-3.062-0.076-4.605c0-3.169-2.575-5.735-5.732-5.735 C263.059,133.226,260.496,135.792,260.496,138.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657762"
    },
    d: "M309.118,252.978c2.411,2.314,4.899,4.555,7.462,6.713c2.411,2.045,6.035,1.74,8.081-0.678 c2.045-2.422,1.742-6.038-0.682-8.084c-2.374-2.005-4.671-4.085-6.906-6.228c-2.285-2.194-5.921-2.118-8.118,0.168 C306.757,247.154,306.833,250.787,309.118,252.978z M272.15,198.624c1.263,3.105,2.626,6.161,4.091,9.162 c1.376,2.853,4.81,4.043,7.664,2.664c2.853-1.382,4.04-4.817,2.664-7.667c-1.351-2.784-2.614-5.618-3.787-8.497 c-1.2-2.933-4.558-4.343-7.487-3.144C272.365,192.339,270.963,195.691,272.15,198.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#657762"
    },
    d: "M364.986,287.672c1.566,0.566,3.118,1.099,4.696,1.61c3.018,0.978,6.25-0.669,7.235-3.684 c0.984-3.014-0.669-6.249-3.687-7.228c-1.465-0.474-2.904-0.972-4.356-1.49c-2.979-1.073-6.262,0.471-7.335,3.453 C360.467,283.314,362.006,286.603,364.986,287.672z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#604C3F"
    },
    d: "M350.782,0H163.367c-26.397,0-47.804,21.403-47.804,47.807v49.808l16.502,16.502l62.5-62.501 l62.509,62.501l62.51-62.501l62.497,62.501l16.502-16.502V47.807C398.583,21.403,377.183,0,350.782,0z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#48B0CA",
      strokeMiterlimit: 10
    },
    x1: 257.075,
    y1: 128.763,
    x2: 257.075,
    y2: 130.038
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595758"
    },
    d: "M222.721,193.144c0,22.18-17.979,40.159-40.162,40.159c-22.184,0-40.156-17.979-40.156-40.159 c0-22.177,17.972-40.159,40.156-40.159C204.741,152.985,222.721,170.967,222.721,193.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.974,192.219c0,15.457-12.525,27.988-27.979,27.988c-15.467,0-27.994-12.531-27.994-27.988 c0-15.46,12.527-27.991,27.994-27.991C200.449,164.229,212.974,176.759,212.974,192.219z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D76A77"
    },
    cx: 184.995,
    cy: 191.001,
    r: 15.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595758"
    },
    d: "M295.444,193.144c0,22.18,17.979,40.159,40.162,40.159c22.183,0,40.162-17.979,40.162-40.159 c0-22.177-17.979-40.159-40.162-40.159C313.423,152.985,295.444,170.967,295.444,193.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.191,192.219c0,15.457,12.525,27.988,27.978,27.988c15.454,0,27.991-12.531,27.991-27.988 c0-15.46-12.538-27.991-27.991-27.991C317.716,164.229,305.191,176.759,305.191,192.219z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D76A77"
    },
    cx: 333.17,
    cy: 191.001,
    r: 15.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.285,
    y: 279.201,
    style: {
      fill: "#EAE9E9"
    },
    width: 152.986,
    height: 33.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.326,
    y: 279.201,
    style: {
      fill: "#9F9E9F"
    },
    width: 8.927,
    height: 33.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.656,
    y: 279.201,
    style: {
      fill: "#9F9E9F"
    },
    width: 8.914,
    height: 33.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.523,
    y: 279.201,
    style: {
      fill: "#9F9E9F"
    },
    width: 8.927,
    height: 33.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.578,
    y: 279.201,
    style: {
      fill: "#9F9E9F"
    },
    width: 8.914,
    height: 33.148
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231815"
    },
    d: "M398.583,146.117V97.616l0,0V47.807c0-26.404-21.4-47.807-47.801-47.807h-97.887v369.717h97.887 c26.4,0,47.801-21.403,47.801-47.807v-31.955v-58.053c22.246-1.67,39.771-20.226,39.771-42.889 C438.354,166.346,420.829,147.787,398.583,146.117z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrankensteinSvgrepoCom);
export default __webpack_public_path__ + "static/media/frankenstein-svgrepo-com.1c316cb5db161635ae5316060389d6d1.svg";
export { ForwardRef as ReactComponent };